import React from 'react';
import { SearchResultCustomer } from './SearchResultCustomer';
import { SearchResultProject } from './SearchResultProject';
import { SearchResultTicket } from './SearchResultTicket';
import { SearchResultUser } from './SearchResultUser';

const renderSection = ({ title, count, rows, renderRow, showSectionCounts = true }) => {
    if (!Array.isArray(rows) || rows.length === 0) {
        return null;
    }

    return (
        <section className="search-results-section" key={title}>
            <div className="search-results-section__header">
                <h6 className="mb-0">{title}</h6>
                {showSectionCounts ? <span>{count}</span> : null}
            </div>
            <div className="search-results-section__body">
                {rows.map((item) => renderRow(item))}
            </div>
        </section>
    );
};

export const SearchResultsList = ({
    query,
    loading,
    error,
    results,
    totalCount,
    onSelectTicket,
    onSelectCustomer,
    onSelectProject,
    onSelectUser,
    showSectionCounts = true,
}) => {
    const normalizedQuery = String(query || '').trim();
    const canSearch = normalizedQuery.length >= 2;

    if (!canSearch) {
        return (
            <div className="search-results-placeholder">
                <div className="search-results-placeholder__title">Estoy buscando...</div>
                <div className="search-results-placeholder__text">Escribe al menos 2 caracteres para buscar tickets, clientes, proyectos o usuarios.</div>
            </div>
        );
    }

    if (loading) {
        return (
            <div className="search-results-placeholder">
                <div className="spinner-border spinner-border-sm text-primary mb-2" role="status" aria-hidden="true" />
                <div className="search-results-placeholder__title">Buscando...</div>
            </div>
        );
    }

    if (error) {
        return (
            <div className="search-results-placeholder">
                <div className="search-results-placeholder__title text-danger">{error}</div>
            </div>
        );
    }

    if (!totalCount) {
        return (
            <div className="search-results-placeholder">
                <div className="search-results-placeholder__title">Sin resultados para «{normalizedQuery}»</div>
            </div>
        );
    }

    return (
        <div className="search-results-groups">
            {renderSection({
                title: 'Tickets',
                count: results.tickets.length,
                rows: results.tickets,
                showSectionCounts,
                renderRow: (item) => (
                    <SearchResultTicket key={item._id} item={item} onSelect={onSelectTicket} />
                ),
            })}
            {renderSection({
                title: 'Clientes',
                count: results.customers.length,
                rows: results.customers,
                showSectionCounts,
                renderRow: (item) => (
                    <SearchResultCustomer key={item._id} item={item} onSelect={onSelectCustomer} />
                ),
            })}
            {renderSection({
                title: 'Proyectos',
                count: results.projects.length,
                rows: results.projects,
                showSectionCounts,
                renderRow: (item) => (
                    <SearchResultProject key={item._id} item={item} onSelect={onSelectProject} />
                ),
            })}
            {renderSection({
                title: 'Usuarios',
                count: results.users.length,
                rows: results.users,
                showSectionCounts,
                renderRow: (item) => (
                    <SearchResultUser key={item._id} item={item} onSelect={onSelectUser} />
                ),
            })}
        </div>
    );
};
